import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ id, name, options, label, selectedValue, onChange, modifier, errorMsg }) => {
  const handleChange = (key) => {
    if (onChange) {
      onChange(key);
    }
  };

  return (
    <fieldset className={`form-item${modifier ? ` form-item--${modifier}` : ''}`}>
      <legend className="form-item__legend">{label}</legend>

      {options.map((option) => (
        <label htmlFor={`${id}-${option.key}`} className="radio__label" key={option.key}>
          <input
            id={`${id}-${option.key}`}
            type="radio"
            name={name}
            value={option.key}
            checked={selectedValue === option.key}
            onChange={() => handleChange(option.key)}
            className="radio__input"
            disabled={option.disabled}
            aria-invalid={option.error}
          />
          <span>{option.value}</span>
        </label>
      ))}

      {errorMsg && (
        <div className="form-item__error-msg">{errorMsg}</div>
      )}
    </fieldset>
  );
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      error: PropTypes.bool
    })
  ).isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  modifier: PropTypes.string,
  errorMsg: PropTypes.string
};

export default Radio;
